import parentLogger from 'services/logger'
import { useEffect, useMemo } from 'react'

export function useLogger(...tags: (string | number)[]) {
  const logger = useMemo(() => {
    if (Array.isArray(tags)) return parentLogger.child({ tags })
    return parentLogger
  }, [tags])

  useEffect(() => {
    logger.debug('mounted')
    return () => logger.debug('unmounted')
  }, [])

  return logger
}
